import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Layout
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

// Sections
import { HeroSection } from "@/components/sections/HeroSection";
import { TokenOverviewSection } from "@/components/sections/TokenOverviewSection";
import { DistributionSection } from "@/components/sections/DistributionSection";
import { VestingSection } from "@/components/sections/VestingSection";
import { TGESupplySection } from "@/components/sections/TGESupplySection";
import { TransparencySection } from "@/components/sections/TransparencySection";
import { DataAPISection } from "@/components/sections/DataAPISection";

// Pages
import AdminPage from "@/pages/AdminPage";

// Main Tokenomics Page
const TokenomicsPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <HeroSection />
        <TokenOverviewSection />
        <DistributionSection />
        <VestingSection />
        <TGESupplySection />
        <TransparencySection />
        <DataAPISection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TokenomicsPage />} />
          <Route path="/admin/tokenomics" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
